export default {
  init() {

    $(function () {
      var shrinkHeader = 100;
      $(window).scroll(function () {
        var scroll = getCurrentScroll();
        if (scroll >= shrinkHeader) {
          $('header').addClass('header_fixed');
        } else {
          $('header').removeClass('header_fixed');
        }
      });

      function getCurrentScroll() {
        return window.pageYOffset;
      }
    });

  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js